<template>
    <div class="mea">
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import Glance from '../Glance';
import TabBar from '../TabBar';
import store from '../../store.js';

export default {
	data () {
	    return {
	      header: {
	        heading: ['name', 'abbreviation', 'description', 'indicator', 'mou', 'sign_Off'],
	        label: 'MEA'
	      },
		};
	},
  	
  beforeRouteEnter (to, from, next) {
  	store.dispatch('fetchSelectedMea', { id: to.params.id });
  	next();
	}
};
</script>

<style lang="scss"></style>


// WEBPACK FOOTER //
// src/components/mea/MEA.vue